import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/scss/pages/auth.scss";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import GoogleLogin from "react-google-login";
import FacebookLogin from "react-facebook-login";
import { SOCIAL_KEYS } from "../../constants";
import useAuth from "../../hooks/useAuth";
import icon_text_content from "../../assets/images/content Unlimited.svg";
import icon_text_cugate from "../../assets/images/cugate-text.svg";
import icon_social_google from "../../assets/images/google.svg";
import { useState } from "react";
import { toast } from "react-toastify";
import { setAddress } from "../../utils/geocode";
import { Icon } from "../../components/widgets";
import { getUserInfo } from "../../actions/user";
import { Backend, Frontend } from "shared-types";

export const AuthPage: React.FC<{ page: number }> = (props) => {
  const navigate = useNavigate();
  const ourLocation = {
    lat: 52.48546014466491,
    lon: 13.34604,
  };
  const { login, register, dispatchUser } = useAuth() as any;
  const [validated, setValidated] = useState(false);
  const geolocationAPI = navigator.geolocation;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confpass: "",
  });

  const getUserCoordinates = async () => {
    if (!geolocationAPI) {
      console.log("Geolocation API is not available in your browser!");
      setDefaultLocation();
    } else {
      geolocationAPI.getCurrentPosition(
        async (position) => {
          const { coords } = position;
          if (coords.latitude > -1000000 && coords.longitude > -1000000) {
            setAddress(coords.latitude, coords.longitude)
              .then(async () => {
                await getUserInfo().then((response) => {
                  dispatchUser(response.data.userInfo);
                });
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            setDefaultLocation();
          }
        },
        async (error) => {
          console.log("Something went wrong getting your position!");
          setDefaultLocation();
        }
      );
    }
  };

  const setDefaultLocation = () => {
    setAddress(ourLocation.lat, ourLocation.lon).then(() => {
      getUserInfo()
        .then((response) => {
          dispatchUser(response.data.userInfo);
        })
        .catch(console.warn);
    });
  };

  const responseGoogle = (response: any) => {
    let uid = response.getBasicProfile().getId();
    let name = response.getBasicProfile().getName();
    let pic = response.getBasicProfile().getImageUrl();
    let email = response.getBasicProfile().getEmail();
    let postData: Backend.T_SignInForm = {
      submit: "web",
      type: "google",
      googleAccessToken: pic,
      email,
      googleId: uid,
      user: name,
    };
    loginAction(postData);
  };

  const responseFacebook = (response: any) => {
    console.log(["facebook=", response]);
    let uid = response.getId();
    let name = response.getName();
    let email = response.getEmail();
    let postData: Backend.T_SignInForm = {
      submit: "web",
      type: "facebook",
      faceBookAccessToken: "accessToken",
      facebookId: uid,
      user: name,
      email: email,
    };
    loginAction(postData);
  };

  const handleLoginSubmit = async (event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      // await getUserCoordinates();
      let data: Backend.T_SignInForm = {
        submit: "web",
        type: "username",
        username: formData.username,
        password: formData.password,
      };
      loginAction(data);
    }
    setValidated(true);
  };

  const handleRegisterSubmit = async (event: {
    currentTarget: any;
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    event.preventDefault();
    if (formData.password !== formData.confpass) {
      formData.confpass = "";
      formData.username = "";
      document.getElementById("confirm_password")?.focus();
      setTimeout(() => {
        toast("Confirm password is not match!");
      }, 200);
      return;
    }
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      let postData: Backend.T_SignUpForm = {
        submit: "web",
        type: "email",
        username: formData.username,
        password: formData.password,
        email: formData.email,
      };
      localStorage.setItem("email", formData.email);
      setLoading(true);
      await register(postData).then(
        async (res: Frontend.T_Response<{ user: Backend.T_User }>["data"]) => {
          const userResponse: any = res.data;
          if (userResponse.data.user.isFailed) {
            toast(userResponse.data.user.message);
            return;
          } else {
            await getUserCoordinates();
            res.message = "Registration successful!";
            toast(res.message);
            window.location.href = "/email-required";
          }
        }
      );
      setLoading(false);
    }
    setValidated(true);
  };

  const loginAction = async (data: Backend.T_SignInForm) => {
    setLoading(true);
    let res: Frontend.T_Response<{ token: string; email?: string }>["data"] =
      await login(data);
    if (res.status === true) {
      navigate("/dashboard");
      res.message = "Login successful!";
    } else if (res.status === "email-verification") {
      if (res.data.email) window.localStorage.setItem("email", res.data.email);
      window.location.href = "/email-required";
    } else {
      setTimeout(() => {
        toast(res.message);
      }, 500);
    }
    setLoading(false);
  };

  return (
    <div
      className={"page page-auth auth-" + (props.page ? "register" : "login")}
    >
      <div className="d-flex justify-content-center mt-5">
        <div
          className="d-flex align-items-center flex-column"
          style={{ width: "100px" }}
        >
          <div className="focus" onClick={() => navigate("/")}>
            <svg
              width="81"
              height="81"
              viewBox="0 0 81 81"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40.6836" cy="40.4211" r="40" fill="#07294C" />
              <path
                d="M40.6838 3.62109C20.388 3.62109 3.88379 20.1253 3.88379 40.4211C3.88379 60.7169 20.388 77.2211 40.6838 77.2211C60.9795 77.2211 77.4838 60.7169 77.4838 40.4211C77.4838 20.1253 61.0911 3.62109 40.6838 3.62109ZM20.2765 32.169C21.8377 35.5144 25.2947 37.8562 29.1977 37.8562C34.662 37.8562 39.1226 33.3956 39.1226 27.9314C39.1226 24.2514 37.1153 21.0175 33.9929 19.3447C36.1117 18.6756 38.342 18.3411 40.6838 18.3411C52.8389 18.3411 62.7638 28.2659 62.7638 40.4211C62.7638 52.5762 52.8389 62.5011 40.6838 62.5011C28.5286 62.5011 18.6038 52.5762 18.6038 40.4211C18.6038 37.5217 19.1614 34.7338 20.2765 32.169Z"
                fill="#DDE9F4"
              />
            </svg>
          </div>
          <img
            className="mt-3"
            alt={""}
            src={icon_text_cugate}
            style={{ width: "100px", cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
          <img
            alt={""}
            src={icon_text_content}
            style={{ width: "100px", cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </div>
      </div>
      <div className="d-flex justify-content-center mt-5">
        {props.page === 0 ? (
          <Form
            noValidate
            className="mt-3"
            validated={validated}
            onSubmit={handleLoginSubmit}
          >
            <Form.Label className="cation d-flex justify-content-center mb-5">
              <h1>Login</h1>
            </Form.Label>
            <Form.Group className="mb-4">
              <Form.Control
                required
                type="text"
                placeholder="User Name"
                value={formData.username}
                onChange={(e) =>
                  setFormData({ ...formData, username: e.target.value })
                }
              />
              <Form.Control.Feedback type="invalid">
                Please fill out user name.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Control
                required
                type="password"
                value={formData.password}
                placeholder="Password"
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
              />
              <Form.Control.Feedback type="invalid">
                Please fill out password.
              </Form.Control.Feedback>
            </Form.Group>
            <div className="d-flex flex-column">
              <div className="d-flex justify-content-center">
                <Button
                  className="w-100 mb-3 login d-flex justify-content-center"
                  type="submit"
                >
                  {loading ? <Icon name="loading" /> : "Login"}
                </Button>
              </div>
              <Form.Label className="d-flex justify-content-center mt-5 mb-5 gray-color">
                Or Sign Up Using
              </Form.Label>
              <div className="d-flex justify-content-center social-buttons mb-5">
                <GoogleLogin
                  className="me-4"
                  clientId={SOCIAL_KEYS.GOOGLE.CLIENT_ID}
                  onSuccess={responseGoogle}
                  onFailure={(e) => console.log(["failure! > ", e])}
                  render={(renderProps) => (
                    <img
                      className="me-2"
                      role="button"
                      src={icon_social_google}
                      onClick={renderProps.onClick}
                      alt="google login"
                    />
                  )}
                />
                <FacebookLogin
                  appId={SOCIAL_KEYS.FACEBOOK.APP_ID}
                  autoLoad={false}
                  fields="name,email,picture"
                  scope="public_profile,user_friends"
                  callback={responseFacebook}
                  icon="fa-facebook"
                />
              </div>
              <div className="d-flex justify-content-center mb-3 gray-color">
                <Link
                  className="me-2"
                  onClick={() => {}}
                  to={"/recovery-password"}
                >
                  Forgot Password
                </Link>
                |
                <Link className="ms-2" onClick={() => navigate("/")} to={""}>
                  Forgot Username
                </Link>
              </div>
              <div className="d-flex justify-content-center mb-5 register">
                <Link to={"/register"}>Registration</Link>
              </div>
            </div>
          </Form>
        ) : (
          <Form
            noValidate
            className="mt-3"
            validated={validated}
            onSubmit={handleRegisterSubmit}
          >
            <Form.Label className="cation d-flex justify-content-center mb-5">
              <h1>Registration</h1>
            </Form.Label>
            <Form.Group className="mb-4">
              <Form.Control
                required
                type="text"
                autoComplete="off"
                placeholder="User Name"
                value={formData.username}
                name="user-name"
                onChange={(e) =>
                  setFormData({ ...formData, username: e.target.value })
                }
              />
              <Form.Control.Feedback type="invalid">
                Please fill out user name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Control
                required
                type="email"
                autoComplete="off"
                placeholder="E-mail"
                value={formData.email}
                name="email"
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
              <Form.Control.Feedback type="invalid">
                Please fill out e-mail.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Control
                required
                type="password"
                autoComplete="off"
                value={formData.password}
                placeholder="Password"
                name="password"
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
              />
              <Form.Control.Feedback type="invalid">
                Please fill out password.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Control
                required
                id="confirm_password"
                type="password"
                autoComplete="off"
                value={formData.confpass}
                placeholder="Confirm Password"
                name="confirm-password"
                onChange={(e) =>
                  setFormData({ ...formData, confpass: e.target.value })
                }
              />
              <Form.Control.Feedback type="invalid">
                Please fill out confirm password.
              </Form.Control.Feedback>
            </Form.Group>
            <div className="d-flex flex-column">
              <div className="d-flex justify-content-center">
                <Button
                  className="w-100 mb-3 login d-flex justify-content-center"
                  type="submit"
                >
                  {loading ? <Icon name="loading" /> : "Registration"}
                </Button>
              </div>
              <Form.Label className="d-flex justify-content-center mt-5 mb-5 gray-color">
                Or Sign Up Using
              </Form.Label>
              <div className="d-flex justify-content-center social-buttons mb-5">
                <GoogleLogin
                  className="me-4"
                  clientId={SOCIAL_KEYS.GOOGLE.CLIENT_ID}
                  onSuccess={responseGoogle}
                  onFailure={(e) => console.log(["failure! > ", e])}
                  render={(renderProps) => (
                    <img
                      className="me-2"
                      role="button"
                      src={icon_social_google}
                      onClick={renderProps.onClick}
                      alt="google login"
                    />
                  )}
                />
                <FacebookLogin
                  appId={SOCIAL_KEYS.FACEBOOK.APP_ID}
                  autoLoad={false}
                  fields="name,email,picture"
                  scope="public_profile,user_friends"
                  callback={responseFacebook}
                  icon="fa-facebook"
                />
              </div>
              <div className="d-flex justify-content-center mb-3 gray-color">
                <Link className="me-2" onClick={() => {}} to={""}>
                  Forgot Password
                </Link>
                |
                <Link className="ms-2" onClick={() => navigate("/")} to={""}>
                  Forgot Username
                </Link>
              </div>
              <div className="d-flex justify-content-center mb-5 gray-color register">
                Already have an account?
                <Link className="ms-2" to={"/login"}>
                  login
                </Link>
              </div>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default AuthPage;
